export default "__VITE_ASSET__BYxB54GM__"